<div style="height: 100%;">  
  <div class="text-center" style="display: flex; min-height: 60vh; justify-content: center; flex-direction: column; max-width: 680px; width: 100%; padding: 10px; margin: 0 auto; flex-grow: 1;">
    <div class="icon onboard-fav-icon" style="margin-left: 5px; padding: 20px;">
      <img class="mb-5" src="../../images/tpiq-logo-small.png" style="border-radius: 5px;  max-height: 40px; margin: 0 auto;"/>
    </div>
    <p>Your last payment did not process. Please contact <a href="mailto:support@taxplaniq.com">support&#64;taxplaniq.com</a> to update your subscription information.</p>
    <p>Thank you.</p>
  </div>
  <div>
  </div>
</div>